import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";

const Wrapper = ({
  children
}) => ___EmotionJSX(React.Fragment, null, children);

export default Wrapper;

if (typeof Wrapper !== 'undefined' && Wrapper && Wrapper === Object(Wrapper) && Object.isExtensible(Wrapper) && !Wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "Wrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/wrapper.js"
    }
  });
}